module.exports = __webpack_public_path__ + "img/idCard3.2ee784e9.png";